// Tenant's binding of the shared api client (@retink/web-ui): env-reading
// stays here in app code; the factory carries the dev-proxy/prod cross-origin
// resolution for the identity-owned auth endpoints.
import { createApi } from '@retink/web-ui'

export { ApiError } from '@retink/web-ui'

const ID_URL = import.meta.env['VITE_ID_URL'] ?? 'https://app.retink.test:9010/signin'
/** This application — used after a tenant switch without creating a second host fact. */
export const APP_URL = import.meta.env['VITE_APP_URL'] ?? window.location.origin
/** Operator surface — agents never remain inside this application. */
export const DESK_URL = import.meta.env['VITE_DESK_URL'] ?? 'https://desk.retink.test:9010'
/** Shareable sign-in entry for organization administrators. */
export const USER_SIGN_IN_URL = `${ID_URL.replace(/\/$/, '')}/login`

// The merged-deploy API host (https://api.retink.ai). Unset in dev → relative paths
// → the Vite proxy routes them. The SPA now serves at the SWA root, but its API
// stays mounted at /app on the shared Function (apps/api/src/app.ts), so own-API
// calls go to ${API_URL}/app and the shared auth API to ${API_URL}/identity. The
// /app prefix is fixed here, NOT derived from BASE_URL (which is now '/'). idUrl
// stays the login-SPA origin (a separate path-app).
const API_URL = import.meta.env['VITE_API_URL'] as string | undefined
const API_PREFIX = '/app'

// The launchable-products registry that feeds the shell's app-rail. This server
// owns it, so dev is a relative path (Vite proxies /api → :9193); prod is the
// /app mount on the shared Function.
export const REGISTRY_URL = API_URL ? `${API_URL}/app/api/registry/products` : '/app/api/registry/products'

export const { api, switchTenant, signOut } = createApi({
  idUrl: ID_URL,
  basePath: API_URL ? `${API_URL}${API_PREFIX}` : API_PREFIX,
  identityOrigin: API_URL ? `${API_URL}/identity` : '/identity',
})
